export default class LabelsListController {}



// WEBPACK FOOTER //
// ./app/common/entities-list/list.controller.js